/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { EnumPropertyConfig } from "./EnumPropertyConfig";
import { BaseProperty } from "./BaseProperty";
import { ArrayableProperty } from "./ArrayableProperty";
export const EnumProperty = core.serialization
    .object({
    multi: core.serialization.boolean().optional(),
    config: EnumPropertyConfig,
})
    .extend(BaseProperty)
    .extend(ArrayableProperty);
